import { trans } from "@mongez/localization";
import { LessonCard } from "../../grades/components/LessonCard";
import { useOfferLessons } from "../hooks";

export function OfferLessonsTab() {
  const { groupedLessons } = useOfferLessons();

  if (!groupedLessons || Object.keys(groupedLessons).length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-8 text-center dark:border-gray-700 dark:bg-gray-800">
        <p className="text-gray-500 dark:text-gray-400">
          {trans("offers.noLessonsIncluded")}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {Object.entries(groupedLessons).map(([grade, lessons]) => (
        <div key={grade} className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            {grade}
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {lessons.map((lesson) => (
              <LessonCard key={lesson.id} lesson={lesson} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
